import { GetServerSideProps } from 'next'
import { useTranslation } from 'next-i18next'

import { createPage } from 'util/ssp'
import Layout from 'components/layout/Layout'
import ForgotPasswordForm from 'components/auth/form/ForgotPasswordForm'

export const getServerSideProps: GetServerSideProps = async function (ctx) {
  return await createPage(ctx, {})
}

export const ForgotPasswordPage = () => {
  const { t } = useTranslation()
  return (
    <Layout title={t('pages.forgot-password.title')}>
      <ForgotPasswordForm />
    </Layout>
  )
}

export default ForgotPasswordPage
